import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
// import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import FooterBottomOne from "../components/FooterBottomOne";
import SupportBarOne from "../components/SupportBarOne";
import NavbarThree from "../components/NavbarThree";
import AnnualReportInner from "../components/AnnualReportInner";


const AnnualReport = () => {
    return (
      <>
        <Fragment>
          <Suspense fallback={<Preloader />}>
             {/* SupportBarOne */}
          <SupportBarOne/>

            {/* Navbar Three*/}
            <NavbarThree/>
  
            {/* Breadcrumb */}
            {/* <Breadcrumb title={"ANNUAL REPORT & NOTICE OF AGM"} imgSrc={"/assets/img/banner/1.png"}/> */}

            {/*Investors Inner */}
            <AnnualReportInner/>
  
            {/* Footer One */}
            <FooterOne />
  
            {/* Footer Bottom One */}
            <FooterBottomOne />
          </Suspense>{" "}
        </Fragment>
      </>
    );
  };
  
  export default AnnualReport;